import {WPAjaxObject} from './WPAjaxObject';
import * as jQuery from 'jquery';
import './libs/jquery.blockUI.js';

export class BloomRegister {
    private is_validating_discount:boolean;
    private is_processing_registration:boolean;

    constructor(private wpAjaxObj:WPAjaxObject, private jQuery:JQuery) {
        this.is_validating_discount = false;
    }

    public init() {
       let $ = jQuery;
      
       $(".bloom_rcp_business_form .discount_btn").on('click', (e:any) => {
            e.preventDefault();

            $('body').trigger( 'rcp_discount_change' );

           this.validate_discount();
       });
       $(".bloom_rcp_business_form .form_submit").on('click', (evt:any) => {
           evt.preventDefault();
           this.send_registration_ajax();
       });
       $(".show-step-1").click(() => {
           this.toggleRegistrationStep("step-1");
       });
       $("body").on("rcp_discount_valid", (evt:any) => {
           this.toggleRegistrationStep('step-2');
       });
       $("body").on("rcp_discount_invalid", () => {
        this.toggleRegistrationStep('step-1');
        });
    }

    public toggleRegistrationStep(step:"step-1"|"step-2") {
        $(".register-step").addClass('hidden'); // hide all steps
        $(".register-" + step).removeClass('hidden'); // now show just the one step we are interested in.
    }

    public send_registration_ajax() {
        var form = $('.bloom_rcp_business_form');

        form.block({
			message: "Please wait",
			css: {
				border: 'none',
				padding: '15px',
				backgroundColor: '#000',
				'-webkit-border-radius': '10px',
				'-moz-border-radius': '10px',
				opacity: .5,
				color: '#fff'
			}
		});

        $('.rcp_message.error', form).remove(); // clear out any messages while we are submitting.
		$('.form_submit', form).val( "Please Wait...");

		// Don't allow form to be submitted multiple times simultaneously
		if( this.is_processing_registration ) {
			return;
		}

        this.is_processing_registration = true;
        let successHandler = (response:any) => {
            // Check for the required properties
            
            if (!response.data) {
                return;
            }

            if (response.data.success !== true ) {
                $('.form_submit', form).val( "Register");
                $('.form_submit', form).before( response.data.errors);

                $('#rcp_register_nonce', form).val( response.data.nonce);
                $('#rcp_registration_form').unblock();
                this.is_processing_registration = false;
                return;
            }

			$('.rcp-submit-ajax', form).remove();
            $('.rcp_message.error', form).remove();
            let response_url = response.data.response_url || '/'; // redirect them to the home screen if we are logged in.
            window.location.href = response_url;
        };
        let errorHandler = (err:any) => {
            this.is_processing_registration = false;
            console.error(err);
            form.unblock();
            $('.form_submit', form).val( "Register");
            $('.form_submit', form).before( "<div class='rcp_message error'><p class='rcp_error server_error'>An error occurred communicating with the server.  Please try again or contact customer support</p>");
        };
        $.ajax({
            type: 'POST'
            ,url: this.wpAjaxObj.ajax_url
            ,data:  form.serialize() + '&action=bloom_register_member&rcp_ajax=true'
            , success: successHandler
            , error: errorHandler
        });
    }

    public validate_discount() {
        if( this.is_validating_discount ) {
            return;
        }
    
        var $ = jQuery;
        
        let discount:string = $('#rcp_discount_code').val() as string;
        var subscription = $('input[name="rcp_level"]').val();
    
        if( ! discount ) {
    
            // Reset everything in case a previous discount was just removed.
            $('.rcp_discount_valid, .rcp_discount_invalid').hide();
            return;
        }
    
        var data = {
            action: 'validate_discount',
            code: discount,
            subscription_id: subscription
        };
    
        this.is_validating_discount = true;
    
        $.post(this.wpAjaxObj.ajax_url, data, (response) => {
    
            $('.rcp_discount_amount').remove();
            $('.rcp_discount_valid, .rcp_discount_invalid').hide();
            
    
            if( ! response.valid ) {
                // code is invalid
                $('.rcp_discount_code_display').html('');
                $('.rcp_discount_invalid').show();
                $('body').trigger('rcp_discount_invalid');
            } else if( response.valid ) {
                $('.rcp_discount_code_display').html(discount);
                $('body').trigger('rcp_discount_valid');
                // code is valid
                $('.rcp_discount_valid').show();
            }
    
            this.is_validating_discount = false;
            $('body').trigger('rcp_discount_applied', [ response ] );
        });
    }
}